import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import API from "@/service/index";
import { AddressType, ContactDuplicateType, LoadingStatusType, TypeComponentNoti } from "@/enums/enums";
import {
  ExceptionCheckDuplicate,
  ExceptionInsertContactTemplate,
  InputInsertContactTemplate,
  ToContactList,
  ValidateInsertContact,
  RedirectContactCreateSuccess,
} from "@/helper/contactHelper";
import { ToSearchedContactAddress } from "@/service/contact/contactFacade";

@Module({ namespaced: true })
export default class Contact extends VuexModule {
  public suggestContactCode = "";
  public contactCodeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public searchedAddressDetail: any = null;
  public searchedContactAddressLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public createContactId: any = null;
  public createContactLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public contactDuplicate: any = null;
  public contactList: any = [];
  public contactListLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getSuggestContactCode(): string {
    return this.suggestContactCode;
  }

  get getContactCodeLoadingStatus(): LoadingStatusType {
    return this.contactCodeLoadingStatus;
  }
  get getSearchedAddressDetail(): any {
    return this.searchedAddressDetail;
  }
  get getSearchedContactAddressLoadingStatus(): LoadingStatusType {
    return this.searchedContactAddressLoadingStatus;
  }
  get getCreateContactId(): any {
    return this.createContactId;
  }
  get getCreateContactLoadingStatus(): LoadingStatusType {
    return this.createContactLoadingStatus;
  }
  get getContactDuplicate(): any {
    return this.contactDuplicate;
  }

  get getContactListLoadingStatus(): LoadingStatusType {
    return this.contactListLoadingStatus;
  }
  get getContactList(): any {
    return this.contactList;
  }
  @Mutation
  public MutationGetSuggestContactCode(contactCode: string) {
    this.suggestContactCode = contactCode;
  }

  @Mutation
  public MutationSetContactCodeLoadingStatus(status: LoadingStatusType) {
    this.contactCodeLoadingStatus = status;
  }

  @Mutation
  MutationSetSearchedAddressDetail(searchedAddress: any) {
    this.searchedAddressDetail = searchedAddress;
  }

  @Mutation
  MutationSetSearchedContactAddressLoadingStatus(status: LoadingStatusType) {
    this.searchedContactAddressLoadingStatus = status;
  }

  @Mutation
  MutationSetCreateContactId(contactId: any) {
    this.createContactId = contactId;
  }

  @Mutation
  MutationSetCreateContactLoadingStatus(status: LoadingStatusType) {
    this.createContactLoadingStatus = status;
  }

  @Mutation
  MutationSetContactDuplicate(contactDuplicate: any) {
    this.contactDuplicate = contactDuplicate;
  }

  @Mutation
  MutationContactList(contactList: any) {
    this.contactList = contactList;
  }

  @Mutation
  MutationSetContactListLoadingStatus(status: LoadingStatusType) {
    this.contactListLoadingStatus = status;
  }

  @Action
  public DoGetSuggestContactCode() {
    if (this.contactCodeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetContactCodeLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoGetSuggestContactCode().then((res) => {
        this.context.commit("MutationGetSuggestContactCode", res.data.contactCode);
        this.context.commit("MutationSetContactCodeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetSearchedContactAddress(taxId: string, branchCode: string) {
    if (this.searchedContactAddressLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetSearchedContactAddressLoadingStatus", LoadingStatusType.Loading);
      this.context.commit("MutationSetSearchedAddressDetail", null);
      const input = {
        taxId: taxId,
        branchCode: branchCode ? branchCode : "00000",
      };
      API.ContactService.DoGetSearchedContactAddress(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const searchedAddress = ToSearchedContactAddress(res.data.searchedAddress);

          if (searchedAddress.addressType !== AddressType.NoAddress) {
            this.context.commit("MutationSetSearchedAddressDetail", searchedAddress);
          }
        }
        this.context.commit("MutationSetSearchedContactAddressLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoCreateContact(contact: any) {
    if (this.createContactLoadingStatus !== LoadingStatusType.Loading) {
      const validateContact = ValidateInsertContact(contact.contactTemplate);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      if (validateContact) {
        this.context.commit("MutationSetCreateContactLoadingStatus", LoadingStatusType.Loading);
        const inputContactTemplate = InputInsertContactTemplate(contact.contactTemplate);
        API.ContactService.DoCreateContact(inputContactTemplate, contact.contactIsDuplicate).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            this.context.commit("MutationSetCreateContactId", res.data.contactId);
            inputAlert.alertMessage = "สร้างผู้ติดต่อสำเร็จ";
            API.ContactService.DoGetAllContact(true)
              .then((resContact) => {
                const contactList = ToContactList(resContact.data.contactList);
                this.context.commit("MutationContactList", contactList);
                this.context.commit("MutationSetContactListLoadingStatus", LoadingStatusType.Success);
                RedirectContactCreateSuccess(res.data.contactId, contact.transactionTypeModel);
              })
              .catch((error) => error);
            this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
            this.context.commit("MutationSetCreateContactLoadingStatus", LoadingStatusType.Success);
          } else {
            inputAlert.alertMessage = ExceptionInsertContactTemplate(res.data, contact.contactTemplate);
            inputAlert.typeMessage = TypeComponentNoti.Error;
            const contactDuplicate = ExceptionCheckDuplicate(res.data, contact.contactTemplate);
            if (contactDuplicate.contactDuplicateType !== ContactDuplicateType.None) {
              this.context.commit("MutationSetContactDuplicate", contactDuplicate);
            } else {
              this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
            }
            this.context.commit("MutationSetCreateContactLoadingStatus", LoadingStatusType.None);
          }
        });
      } else {
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: "โปรดกรอกข้อมูลในช่องไฮไลท์สีแดงให้ถูกต้อง",
            typeMessage: TypeComponentNoti.Error,
          },
          { root: true }
        );
        this.context.commit("MutationSetCreateContactLoadingStatus", LoadingStatusType.Fail);
      }
    }
  }

  @Action
  public DoGetAllContact(isUseMainDatabase = false) {
    if (this.contactListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetContactListLoadingStatus", LoadingStatusType.Loading);
      API.ContactService.DoGetAllContact(isUseMainDatabase)
        .then((res) => {
          const contactList = ToContactList(res.data.contactList);
          this.context.commit("MutationContactList", contactList);
          this.context.commit("MutationSetContactListLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }
}
